// Single source of truth for club LIFECYCLE status → badge display. Shared by every
// superadmin screen (Clubs list, Club detail, Subscriptions) so a status can never be
// mislabeled by a screen-local map again (e.g. 'archived' → "Suspended").
//
// Superadmin pages use their own dark inline-hex palette (not the app's Tailwind theme
// tokens), so getStatusBadge() exposes an inline `style` object; a `colorClasses` string
// (light + dark) is also provided for any non-SA caller.

export const CLUB_STATUS = {
  trial:         { label: 'Trial',         color: 'blue'  },
  trialing:      { label: 'Trial',         color: 'blue'  },
  active:        { label: 'Active',        color: 'green' },
  trial_expired: { label: 'Trial Expired', color: 'amber' },
  suspended:     { label: 'Suspended',     color: 'red'   },
  archived:      { label: 'Archived',      color: 'gray'  },
  cancelled:     { label: 'Cancelled',     color: 'gray'  },
  pending_deletion: { label: 'Pending deletion', color: 'red' },
};

// Semantic color → superadmin dark-theme inline hex (tinted background + text).
const HEX = {
  blue:  { bg: 'rgba(96,165,250,0.12)',  text: '#60a5fa' },
  green: { bg: 'rgba(52,211,153,0.12)',  text: '#34d399' },
  amber: { bg: 'rgba(251,191,36,0.12)',  text: '#fbbf24' },
  red:   { bg: 'rgba(248,113,113,0.12)', text: '#f87171' },
  gray:  { bg: 'rgba(107,114,128,0.12)', text: '#9ca3af' },
};

// Semantic color → Tailwind utility classes (light + dark), for non-SA callers.
const TW = {
  blue:  'bg-blue-500/15 text-blue-600 dark:text-blue-400',
  green: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
  amber: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
  red:   'bg-red-500/15 text-red-600 dark:text-red-400',
  gray:  'bg-gray-500/15 text-gray-500 dark:text-gray-400',
};

// getStatusBadge(status) → { label, color, style, colorClasses }
// Unknown/missing status falls back to Trial styling (never to Suspended — that was the bug).
export function getStatusBadge(status) {
  const meta = CLUB_STATUS[status] || CLUB_STATUS.trial;
  const hex  = HEX[meta.color] || HEX.gray;
  return {
    label:        meta.label,
    color:        meta.color,
    style:        { background: hex.bg, color: hex.text },
    colorClasses: TW[meta.color] || TW.gray,
  };
}
